const STATUS_KEYS = { processing: 'processing', onHold: 'processing', shipped: 'shipped', delivered: 'delivered' }

/**
 * What the billing row shows for a scope order: null for statuses a practice should not see,
 * otherwise the status key and, once shipped, every shipment that has a tracking number.
 */
export const getShipmentView = order => {
  const statusKey = STATUS_KEYS[order?.status]
  if (!statusKey) return null

  const trackings =
    statusKey === 'processing'
      ? []
      : (Array.isArray(order.shipments) ? order.shipments : [])
          .filter(shipment => shipment?.trackingNumber)
          .map(({ trackingNumber, trackingUrl }) => ({ trackingNumber, trackingUrl: trackingUrl || null }))

  return { statusKey, trackings }
}

export const indexScopeOrdersByInvoice = orders =>
  (orders || []).reduce((byInvoice, order) => {
    if (order?.stripeInvoiceId) byInvoice[order.stripeInvoiceId] = order
    return byInvoice
  }, {})

// refunds share the invoice id of the purchase they refund, so only the purchase row carries the shipment
export const getTransactionScopeOrder = (transaction, scopeOrdersByInvoice) =>
  transaction?.type !== 'refund' && transaction?.invoiceStripeId
    ? scopeOrdersByInvoice[transaction.invoiceStripeId]
    : undefined
